var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFindInPageDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8029_11696",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 77,
    height: 77
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 76.4364,
    height: 76.4364,
    fill: "#004DDD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8029_11696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1091 70.0667C17.3574 70.0667 15.8579 69.4431 14.6105 68.1957C13.3631 66.9483 12.7394 65.4487 12.7394 63.6971V12.7395C12.7394 10.9878 13.3631 9.48825 14.6105 8.24085C15.8579 6.99345 17.3574 6.36975 19.1091 6.36975H47.7728L63.697 25.4789V62.5824L49.2059 47.7728C49.7898 46.8704 50.2277 45.8884 50.5197 44.8268C50.8116 43.7652 50.9576 42.624 50.9576 41.4031C50.9576 37.8998 49.7102 34.9007 47.2154 32.4059C44.7206 29.9111 41.7215 28.6637 38.2182 28.6637C34.7149 28.6637 31.7158 29.9111 29.221 32.4059C26.7262 34.9007 25.4788 37.8998 25.4788 41.4031C25.4788 44.9064 26.7262 47.9055 29.221 50.4003C31.7158 52.8951 34.7149 54.1425 38.2182 54.1425C39.4391 54.1425 40.5803 53.9965 41.6419 53.7046C42.7035 53.4126 43.6855 52.9747 44.5879 52.3908L61.1491 68.7928C59.9283 69.3236 58.6543 69.6686 57.3273 69.8279C56.0003 69.9871 54.6733 70.0667 53.3462 70.0667H19.1091ZM38.2182 47.7728C36.4665 47.7728 34.967 47.1491 33.7196 45.9017C32.4722 44.6543 31.8485 43.1548 31.8485 41.4031C31.8485 39.6514 32.4722 38.1519 33.7196 36.9045C34.967 35.6571 36.4665 35.0334 38.2182 35.0334C39.9699 35.0334 41.4694 35.6571 42.7168 36.9045C43.9642 38.1519 44.5879 39.6514 44.5879 41.4031C44.5879 43.1548 43.9642 44.6543 42.7168 45.9017C41.4694 47.1491 39.9699 47.7728 38.2182 47.7728Z",
    fill: "#FAFAFA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindInPageDark);
export default __webpack_public_path__ + "static/media/find_in_page_dark.81e613b5a69dee469b8228577f3a55f6.svg";
export { ForwardRef as ReactComponent };